
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTrackNo as ObiTrackNoElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-track-no.js';
 
 
 

 
 export const ObiTrackNo = createComponent({
   react: React,
   tagName: 'obi-track-no',
   elementClass: ObiTrackNoElement,
   events: {
     
   }
  });
 
 